import { render } from "./ShareButton.vue?vue&type=template&id=372a1c06&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"

import "./ShareButton.vue?vue&type=style&index=0&id=372a1c06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-372a1c06"

export default script